import { HttpClient } from "../HttpClient";
/**
 * * Post Content
 */
export const PostContent = async (content) => {
	try {
		const { data } = await HttpClient.post("api/contents", { ...content });
		return await Promise.resolve(data);
	} catch (err) {
		return Promise.reject(err);
	}
};
